
import { IFreehandShapeUponCreation, IZoneMapLocationUponCreation } from './types';
import { ZoneEntity, ZoneType } from '@src/core/features';

export interface IZonesInitialState {
  selectedZone: ZoneEntity | null;
  collapse: {
    [ZoneType.TEMPORARY]: boolean;
    [ZoneType.PERMANENT]: boolean;
  };
  zoneMapLocationUponCreation: IZoneMapLocationUponCreation | null;
  freehandShapeUponCreation: IFreehandShapeUponCreation | null;
}

const initialState: IZonesInitialState = {
  selectedZone: null,
  collapse: {
    [ZoneType.TEMPORARY]: true,
    [ZoneType.PERMANENT]: true,
  },
  zoneMapLocationUponCreation: null,
  freehandShapeUponCreation: null,
};

export default initialState;
